import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private http: HttpClient) {}

  refreshToken(refreshToken: string) {
    const url = `/api/device-sales/v1/auth/refresh-token`;
    const headers = new HttpHeaders({
      'x-authorization': `Bearer ${refreshToken}`,
    });
    return this.http.post<any>(url,{}, { headers }).pipe(
      catchError((error: any) => {
        throw error;
      }),
    );
  }
}
